/**
 * 天候データ統合版 売上分析ダッシュボード
 */

import React, { useState } from 'react';
import SalesAnalytics from './SalesAnalytics';
import WeatherSalesAnalysis from './WeatherSalesAnalysis';
import AdvancedSalesAnalysisV2 from './AdvancedSalesAnalysisV2';
import { BarChart3, CloudRain, Filter } from 'lucide-react';

import PageContainer from '../layout/PageContainer';
const SalesAnalyticsWithWeather: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'sales' | 'weather' | 'advanced'>('sales');

  return (
    <PageContainer>{/* タブナビゲーション */}
      <div className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4">
          <div className="flex space-x-1">
            <button
              onClick={() => setActiveTab('sales')}
              className={`
                flex items-center gap-2 px-6 py-4 border-b-2 transition-colors
                ${activeTab === 'sales' 
                  ? 'border-blue-600 text-blue-600 font-semibold' 
                  : 'border-transparent text-gray-600 hover:text-gray-800'
                }
              `}
            >
              <BarChart3 className="w-5 h-5" />
              <span>売上分析</span>
            </button>
            <button
              onClick={() => setActiveTab('weather')}
              className={`
                flex items-center gap-2 px-6 py-4 border-b-2 transition-colors
                ${activeTab === 'weather' 
                  ? 'border-blue-600 text-blue-600 font-semibold' 
                  : 'border-transparent text-gray-600 hover:text-gray-800'
                }
              `}
            >
              <CloudRain className="w-5 h-5" />
              <span>天候分析</span>
            </button>
            <button
              onClick={() => setActiveTab('advanced')}
              className={`
                flex items-center gap-2 px-6 py-4 border-b-2 transition-colors
                ${activeTab === 'advanced' 
                  ? 'border-blue-600 text-blue-600 font-semibold' 
                  : 'border-transparent text-gray-600 hover:text-gray-800'
                }
              `}
            >
              <Filter className="w-5 h-5" />
              <span>高度な分析</span>
            </button>
          </div>
        </div>
      </div>

      {/* コンテンツエリア */}
      <div className="container mx-auto px-4 py-6">
        {activeTab === 'sales' && <SalesAnalytics />}
        {activeTab === 'weather' && <WeatherSalesAnalysis />}
        {activeTab === 'advanced' && <AdvancedSalesAnalysisV2 />}
      </div>
    </PageContainer>
  );
};

export default SalesAnalyticsWithWeather;